var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgComment(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M46.5 46.5H45C38.8345 46.4997 32.8758 44.2769 28.2164 40.2392L26.6389 38.8719C25.7618 38.9572 24.8812 38.9999 24 39C18.0443 39 12.4327 37.0846 8.19863 33.6067C3.87891 30.0584 1.5 25.3148 1.5 20.25C1.5 15.1852 3.87891 10.4416 8.19863 6.89334C12.4327 3.41541 18.0443 1.5 24 1.5C29.9557 1.5 35.5673 3.41541 39.8014 6.89334C44.1211 10.4416 46.5 15.1852 46.5 20.25C46.4979 22.9423 45.8184 25.5909 44.524 27.9517C43.4005 30.0078 41.9043 31.8369 40.1117 33.3457C41.4513 36.7522 43.4761 39.8474 46.0606 42.4395L46.5 42.8787V46.5ZM27.6052 35.7396L30.1812 37.9721C33.7341 41.051 38.1577 42.947 42.8375 43.3965C40.2554 40.5103 38.2614 37.148 36.9671 33.4981L36.5551 32.3297L37.4184 31.6671C41.3403 28.6573 43.5 24.6027 43.5 20.25C43.5 11.5654 34.7523 4.5 24 4.5C13.2477 4.5 4.5 11.5654 4.5 20.25C4.5 28.9346 13.2477 36 24 36C24.984 35.9999 25.967 35.94 26.9437 35.8207L27.6052 35.7396Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgComment);
export default __webpack_public_path__ + "static/media/comment.479e6a51ac1553c570a983fe6b146262.svg";
export { ForwardRef as ReactComponent };